import { render, staticRenderFns } from "./series_success.vue?vue&type=template&id=24b25e13"
import script from "./series_success.vue?vue&type=script&lang=js"
export * from "./series_success.vue?vue&type=script&lang=js"
import style0 from "./series_success.vue?vue&type=style&index=0&id=24b25e13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports